import { render, staticRenderFns } from "./BannerAspectRatioDetailView.vue?vue&type=template&id=459a49ed&scoped=true"
import script from "./BannerAspectRatioDetailView.vue?vue&type=script&lang=js"
export * from "./BannerAspectRatioDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459a49ed",
  null
  
)

export default component.exports